import Cookies from 'js-cookie';
import actions from './actions';
import { API_HOST, API } from '../../config/api'
import axios from 'axios';
import {setRefreshToken, setToken} from '../../services/authenticationService'
import actionsAlert from "../alert/actions"

const { loginSuccess, logoutSuccess } = actions;
const { alertError } = actionsAlert;

/* login */
const login = (values, history) => {
  return async dispatch => {
    const URL = API_HOST + API.auth.login
    axios.post(URL, values).then(
      (res) => {
          setToken(res.data.token)
          setRefreshToken(res.data.refresh_token)
          Cookies.set('logedIn', true);
          history.push('/admin');
          return dispatch(loginSuccess(true));
      },
      (err) => {
          console.log(err.response.data.message)
          if(err.response.data.msg)
          dispatch(alertError({ msg: err.response.data.message , type: 'error' }));
          else
          dispatch(alertError({ msg: 'Erreur d\'authentification' , type: 'error' }));

      }
    )
  };
};

/* logout */
const logOut = () => {
  return async dispatch => {
    try {
      Cookies.remove('logedIn');
      dispatch(logoutSuccess(null));
    } catch (err) { }
  };
};

export { login, logOut };
